import "./../Stylesheets/Main.css"


const BackgroundImage = ({ Path }) => {
    return (
         <img src={Path} alt="News Thumbnail" className="back-image" />  
    );
}

export default BackgroundImage;